import React, { useContext } from 'react';
import cls from './BodyComponents.module.css';
import classNames from 'classnames';
import { ModalAddContext } from '../ModalAdd';

export const TabPanel = () => {
    const { activeTab, setActiveTab, setErrors, setFormState } = useContext(ModalAddContext);
    return (
        <div className={classNames(cls.tapPanel)}>
            <div
                onClick={() => {
                    setActiveTab('company');
                    setErrors({
                        company: null,
                        employee: null,
                        notBind: null,
                    });
                    setFormState((prevState) => ({ ...prevState, user_bind: null }));
                }}
                className={classNames(cls.tapPanelItem, { [cls.active]: activeTab === 'company' })}
            >
                {i18next.t('Accounts.TabPanel.return.company')}
            </div>
            <div
                onClick={() => {
                    setActiveTab('employee');
                    setErrors({
                        company: null,
                        employee: null,
                        notBind: null,
                    });
                    setFormState((prevState) => ({ ...prevState, user_bind: null }));
                }}
                className={classNames(cls.tapPanelItem, { [cls.active]: activeTab === 'employee' })}
            >
                {i18next.t('Accounts.TabPanel.return.employee')}
            </div>
            <div
                onClick={() => {
                    setActiveTab('notBind');
                    setErrors({
                        company: null,
                        employee: null,
                        notBind: null,
                    });
                    setFormState((prevState) => ({ ...prevState, user_bind: null }));
                }}
                className={classNames(cls.tapPanelItem, { [cls.active]: activeTab === 'notBind' })}
            >
                {i18next.t('Accounts.TabPanel.return.notBind')}
            </div>
        </div>
    );
};
